import { Tooltip } from "antd";

const STYLES = {
  low: "bg-[#27AE601A] text-[#219653]",
  medium: "bg-[#F2C94C33] text-[#B7791F]",
  high: "bg-[#EB57571A] text-[#EB5757]",
};

/**
 * Risk level pill. Hover shows the score and the reasons behind it.
 */
const RiskBadge = ({ risk }) => {
  if (!risk) return <span className="text-[#A0A3BD]">—</span>;
  const { level, score, reasons = [], override } = risk;

  const tip = (
    <div className="text-[12px] space-y-1">
      <div>Score: {score}/100</div>
      {override && <div>Set manually{override.note ? `: ${override.note}` : ""}</div>}
      {reasons.map((r) => (
        <div key={r.reason}>
          +{r.points} {r.reason}
        </div>
      ))}
    </div>
  );

  return (
    <Tooltip title={tip}>
      <span
        className={`${STYLES[level] || ""} rounded-[3px] px-[10px] py-[3px] text-[13px] capitalize whitespace-nowrap`}
      >
        {level}
        {override ? " •" : ""}
      </span>
    </Tooltip>
  );
};

export default RiskBadge;
